import React from "react";
import classes from "./ScheduleSelection.module.scss";
import closeIcon from "../../../assets/images/closeIcon.png";
import cx from "classnames";
import * as ROUTES from "../../../constants/routes";

const scheduleSelection = (props) => {
  let scheduleSelectionValues = props.scheduleSelectionValues;

  let scheduleSelectionSelect = "";
  switch (props.schedulePlan) {
    case ROUTES.PAGE_3_CHOICES_2:
      scheduleSelectionSelect =
        scheduleSelectionValues[ROUTES.PAGE_3_CHOICES_2];
      break;
    case ROUTES.PAGE_3_CHOICES_3:
      scheduleSelectionSelect =
        scheduleSelectionValues[ROUTES.PAGE_3_CHOICES_3];
      break;
    case ROUTES.PAGE_3_CHOICES_4:
      scheduleSelectionSelect =
        scheduleSelectionValues[ROUTES.PAGE_3_CHOICES_4];
      break;
    case ROUTES.PAGE_3_CHOICES_5:
      scheduleSelectionSelect =
        scheduleSelectionValues[ROUTES.PAGE_3_CHOICES_5];
      break;

    default:
      break;
  }

  const getPlanName = (uuid) => {
    let selectedSchedule;
    if (scheduleSelectionSelect.plan && scheduleSelectionSelect !== "") {
      selectedSchedule = scheduleSelectionSelect.plan.filter(
        (p) => p.uuid === uuid
      );
      return selectedSchedule[0].title;
    } else {
      return "";
    }
  };

  let scheduleSelectionBody =
    scheduleSelectionSelect !== ""
      ? scheduleSelectionSelect.plan.map((res, index) => (
          <div
            key={index}
            className={cx(
              classes.scheduleSelectionPlan,
              res.buildPlan ? classes.scheduleSelectionPlanBuild : "",
              res.soldOut ? classes.scheduleSoldOut : ""
            )}
          >
            <div className={classes.scheduleSelectionPlanTitle}>
              {res.title}
            </div>
            <div className={classes.scheduleSelectionPlanDescription}>
              <span>
                {res.description}
                <br />
                {res.subDescription}
              </span>
            </div>
            {res.games && !res.buildPlan && (
              <>
                <div className={classes.scheduleSelectionPlanGames}>
                  <h3>Schedule</h3>
                  <ul>
                    {res.games.map((game, i) => {
                      return <li key={i + 100}>{game}</li>;
                    })}
                  </ul>
                </div>
                {res.soldOut ? (
                  <div className={classes.scheduleSelectionButton}>
                    Sold Out
                  </div>
                ) : (
                  <div
                    className={classes.scheduleSelectionButton}
                    onClick={() => {
                      if (window.adobeAnalytics && window.adobeAnalytics.tl) {
                        window.adobeAnalytics.t({
                          pageName:
                            "Washington Nationals: Tickets: Nationals Ticketfinder: Schedule Selection",
                        });
                        window.adobeAnalytics.tl(
                          true,
                          "o",
                          `Washington Nationals: Tickets: Nationals Ticketfinder: Schedule Selection: schedule selection: ${getPlanName(
                            res.uuid
                          )} : select plan button click`,
                          {
                            prop12: "Nationals TicketFinder",
                            prop13:
                              "Washington Nationals: Tickets: Nationals Ticketfinder: Schedule Selection",
                            prop14: `schedule selection: ${getPlanName(
                              res.uuid
                            )} : select plan button click`,
                          }
                        );
                      }
                      props.onClickScheduleSelected(res.uuid);
                    }}
                  >
                    Select Plan
                  </div>
                )}
              </>
            )}
            {res.games && res.buildPlan && (
              <a href={res.buttonUrl} target="_blank" rel="noopener noreferrer">
                <div className={classes.scheduleSelectionButton}>
                  Select Plan
                </div>
              </a>
            )}
          </div>
        ))
      : "";

  return (
    <div
      className={cx(
        classes.modal,
        props.showScheduleSelection ? classes.modalActive : ""
      )}
    >
      <div className={classes.scheduleSelection}>
        <div className={classes.scheduleSelectionTitle}>Schedule Selection</div>
        <div className={classes.scheduleSelectionSubTitle}>
          {scheduleSelectionSelect.header}
          <br />
          {scheduleSelectionSelect.subHeader}
        </div>
        <div className={classes.scheduleSelectionPlanWrapper}>
          {scheduleSelectionBody}
        </div>
        {(props.schedulePlan === ROUTES.PAGE_3_CHOICES_1 ||
          props.schedulePlan === ROUTES.PAGE_3_CHOICES_2 ||
          props.schedulePlan === ROUTES.PAGE_3_CHOICES_3) && (
          <div className={classes.scheduleSelectionDisclaimer}>
            All 2021 access, benefits, promotions, seating locations, and events
            (including, without limitation, location, dates and times) are
            subject to change without notice based on the ongoing developments
            of the COVID-19 pandemic.
          </div>
        )}
        <img
          className={classes.closeIcon}
          src={closeIcon}
          alt="Close Icon"
          onClick={() => props.onClickCloseScheduleSelection()}
        />
      </div>
    </div>
  );
};

export default scheduleSelection;
